module.exports = __webpack_public_path__ + "static/email/img/choose_messge.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/choose_messge.png
// module id = EvhG
// module chunks = 1